import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Button from './Button';
import Overlay from './Overlay';
import SectionHeader from './SectionHeader';
import CloseButton from '../../assets/dynamic-color-svgs/CloseButton';

const Modal = ({ modalState, closeModal }) => {
  const {
    title,
    body,
    primaryActionLabel,
    primaryActionCallback,
    secondaryActionLabel,
    secondaryActionCallback,
  } = modalState;

  return ReactDOM.createPortal(
    <div className="fixed inset-x-0 top-0 flex h-screen w-screen flex-col items-center justify-center px-4">
      {/* z-10 */}
      <Overlay onEscape={closeModal} />

      {/* z-20 */}
      <section
        className="z-20 flex max-h-[80vh] min-h-40 w-[85vw] min-w-72 max-w-md  flex-col gap-5 rounded-lg bg-white p-6 shadow-pj-xl"
        role="dialog"
        aria-modal="true"
      >
        <CloseButton closeModal={closeModal} />
        <div>
          {title && <SectionHeader text={title} />}
          <div className="custom-scrollbar max-h-[60vh] overflow-auto">
            {body}
          </div>
        </div>

        <div className="flex flex-col justify-center gap-2 xs:flex-row">
          {primaryActionCallback && (
            <Button
              variant="primary"
              text={primaryActionLabel}
              type="button"
              onClick={primaryActionCallback}
            />
          )}
          {secondaryActionCallback && (
            <Button
              variant="dark"
              text={secondaryActionLabel}
              type="button"
              onClick={secondaryActionCallback}
            />
          )}
        </div>
      </section>
    </div>,
    document.getElementById('modal-root'),
  );
};

const modalStatePropTypes = PropTypes.shape({
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  body: PropTypes.node.isRequired,
  primaryActionLabel: PropTypes.string,
  primaryActionCallback: PropTypes.func,
  secondaryActionLabel: PropTypes.string,
  secondaryActionCallback: PropTypes.func,
});

Modal.propTypes = {
  modalState: modalStatePropTypes,
  closeModal: PropTypes.func.isRequired,
};

export default Modal;
